import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type SupplierDetailResponse } from '../types';
import { zodSupplierDetailResponseSchema } from '../validations';

/**
 * Removes one responsible person from a supplier relationship, leaving the
 * others in place.
 *
 * @param deId - The data exchange ID of the supplier relationship.
 * @param userId - The user ID of the responsible person to remove.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The refreshed supplier detail response, so the caller sees which
 * owner the mirrored single-person fields fell back to.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/delete_supplier_responsible_person_suppliers__de_id__responsible_persons__user_id__delete
 */
export const deleteSupplierResponsiblePerson = async (
  deId: UUID,
  userId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .delete(ENDPOINT.SUPPLIER.DELETE_RESPONSIBLE_PERSON(deId, userId), {
      ...options,
      validate: {
        response: zodSupplierDetailResponseSchema,
      },
    })
    .json<SupplierDetailResponse>();
